import React from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import numeral from "numeral";

const LavenderBackground = styled.div`
  & {
    background:#FAFAFA;   
    padding: 50px 110px;
    margin-bottom:50px;
  }
`;
const ValueContainer = styled(Grid)`&& {
    background: #DADCE0;        
    padding:40px 0;
  }
`;

const Value = styled.div`& {
    font-family: Work Sans;
    font-style: normal;
  align-items:center;
  background:#DADCE0;
  color:#000;
  display:flex;
  flex-flow: column nowrap;
  margin-bottom:16px;
    font-size: 40px;    
  }
`;
const Label = styled.div`
  & {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;   
    text-transform:uppercase;
    font-size:13px !important;
    font-size:14px;    
    color: #5F6368;
  }
`;
const CapCosts = ({ capResult }) => (
  <LavenderBackground>
    <ValueContainer container direction="column" justify="center" alignItems="center" spacing={32}>
      <Grid container item direction="column" alignItems="center" spacing={16}>
        <Grid item>
          <Value>{numeral(capResult.marketCost).format("$0,00")}</Value>
        </Grid>
        <Grid item>
          <Label>MARKET COST</Label>
        </Grid>
      </Grid>
      <Grid container item direction="column" alignItems="center" spacing={16}>
        <Grid item>
          <Value>{numeral(capResult.marketCost / capResult.notional).format("0.000%")}</Value>
        </Grid>
        <Grid item>
          <Label>PERCENT OF NOTIONAL</Label>
        </Grid>
      </Grid>
    </ValueContainer>
  </LavenderBackground>
);

export default CapCosts;

